import {DirectiveBinding} from "vue/types/options";

function focusInvalidInput(binding: any) {
  setTimeout(() => {
    const editButtonRef = (binding.querySelector('div.v-input.error--text input') as HTMLInputElement)
    if (editButtonRef) {
      editButtonRef.scrollIntoView({behavior: "smooth"})
      editButtonRef.focus()
    }
  })
}

export const FocusInvalidInputDirective = {
  bind(el: HTMLElement, binding: DirectiveBinding) {
    el.addEventListener('submit', () => focusInvalidInput(el))
  },
  unbind(el: HTMLElement, binding: DirectiveBinding) {
    el.removeEventListener('submit', focusInvalidInput)
  }

};

